import * as Sentry from '@sentry/react';
import { GetServerSidePropsContext } from 'next';

import { redirect, TPagePropsForJwtAuthentication, TRedirect } from '@/common/next/authenticate';
import { INTERNAL_SERVER_ERROR } from '@/constants/commons/statusCode';

type TGetPromiseValue<T> = T extends Promise<infer U> ? U : never;
// getServerSidePropsでは何も値を返したくない場合でも{ props: {} }を返す必要があり、それに適合した型
export type TNoReturnValue = { [key: string]: string };

export const wrapGetServerSideProps = <U extends Promise<unknown>, K extends TGetPromiseValue<U>>(
  fn: (context: GetServerSidePropsContext) => Promise<{ props?: TPagePropsForJwtAuthentication; redirect?: TRedirect }>,
): ((
  context: GetServerSidePropsContext,
) => Promise<{ props?: TPagePropsForJwtAuthentication; redirect?: TRedirect }>) => {
  const wrapFunc = async (
    context: GetServerSidePropsContext,
  ): Promise<{ props?: TPagePropsForJwtAuthentication; redirect?: TRedirect }> => {
    let result: { props?: TPagePropsForJwtAuthentication; redirect?: TRedirect };

    try {
      result = await fn(context);
    } catch (e) {
      Sentry.captureException(e);
      return redirect(`/${INTERNAL_SERVER_ERROR}`);
    }
    return result;
  };
  return wrapFunc;
};
